require('!modernizr-loader!json-loader!./.modernizrrc');
require('./polyfills.js');
require('apply!callback!./components.js');



// WEBPACK FOOTER //
// ./frontend/main.js